/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Metrics.AchievementType_
///   This is an auto-generated enumeration of the SWFC_Learning.Metrics.AchievementType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum AchievementType_ {
   /// <summary>
   ///   Content Based (cont)
   /// </summary>
   ContentBased = 1,
   /// <summary>
   ///   Completion Based (comp)
   /// </summary>
   CompletionBased = 2
}

export const AchievementTypes: AchievementType[] = [
   {
      code: AchievementType_.ContentBased,
      literal: 'ContentBased',
      description: 'Content Based',
      shortDescription: 'cont',
      listPriority: 0,

      typeName: "AchievementType"
   },
   {
      code: AchievementType_.CompletionBased,
      literal: 'CompletionBased',
      description: 'Completion Based',
      shortDescription: 'comp',
      listPriority: 0,

      typeName: "AchievementType"
   }
]

export class AchievementType implements IDomainModel {
   code: AchievementType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: AchievementType_): AchievementType {
      return AchievementTypes.find(d => d.code === code)
   }
}
